import { SendNotificationPayload } from "@/data/payload/dashboard/send-notification-payload";
import { DashboardRepository } from "@/domain/repository/dashboard-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class SendNotificationUsecase {
  constructor(private readonly dashboardRepo: DashboardRepository) {}

  async execute(payload: SendNotificationPayload): Promise<SATResult<void, SATError>> {
    return this.dashboardRepo.sendNotification(payload);
  }
}
